import { render } from "./ImportarPedidos.vue?vue&type=template&id=e8864452"
import script from "./ImportarPedidos.vue?vue&type=script&lang=js"
export * from "./ImportarPedidos.vue?vue&type=script&lang=js"

import "./ImportarPedidos.vue?vue&type=style&index=0&id=e8864452&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__